import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { MessageSquare } from "lucide-react";
import { useI18n } from "@/i18n";
import { useAuth } from "@/AuthContext";
import api from "@/api";
import { ChatDialog } from "@/components/ChatDialog";
import { useNavigate } from "react-router-dom";

export default function Messages() {
  const { t } = useI18n();
  const { user } = useAuth();
  const nav = useNavigate();
  const [threads, setThreads] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => { if (user === false) nav("/login"); }, [user, nav]);
  const loadThreads = () => api.get("/threads").then((r) => setThreads(r.data));
  useEffect(() => { if (user && user !== false) loadThreads(); }, [user]); // eslint-disable-line

  return (
    <div className="max-w-3xl mx-auto px-5 sm:px-8 py-14">
      <h1 className="font-display text-3xl sm:text-4xl font-black tracking-tight text-[#2D231F] mb-8">{t("chat.title")}</h1>
      {threads.length === 0 ? (
        <p className="text-[#A89A90] py-16 text-center">{t("chat.noThreads")}</p>
      ) : (
        <div className="space-y-3">
          {threads.map((th, i) => (
            <motion.button key={`${th.job_id}-${th.craftsman_user_id}`} data-testid={`thread-${i}`}
              initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.04 }}
              onClick={() => setActive(th)}
              className="w-full text-left rounded-xl border border-[#EBDDD3] bg-white p-5 hover:shadow-md transition-shadow flex items-center gap-4">
              <span className="w-11 h-11 rounded-full bg-[#5C6646]/10 flex items-center justify-center shrink-0">
                <MessageSquare className="w-5 h-5 text-[#5C6646]" />
              </span>
              <div className="min-w-0 flex-1">
                <div className="flex items-center justify-between gap-2">
                  <span className={`text-[#2D231F] truncate ${th.unread ? "font-black" : "font-semibold"}`}>{th.unread && <span data-testid={`unread-dot-${i}`} className="inline-block w-2.5 h-2.5 rounded-full bg-[#C65338] mr-2 align-middle" />}{th.other_name}{th.needs_reply && !th.unread && <span className="ml-2 px-2 py-0.5 rounded-full bg-[#E69625]/15 text-[#B27A1E] text-[10px] font-bold uppercase">{t("chat.needsReply")}</span>}
                  {th.kind === "offer" && <span className="ml-2 px-2 py-0.5 rounded-full bg-[#E69625]/15 text-[#B27A1E] text-[10px] font-bold uppercase">{t("chat.newOffer")}</span>}</span>
                  <span className="text-xs text-[#A89A90] shrink-0">{th.job_title}</span>
                </div>
                <p className={`text-sm truncate ${th.unread ? "text-[#2D231F] font-semibold" : "text-[#8C7A70]"}`}>{th.last_message}</p>
              </div>
            </motion.button>
          ))}
        </div>
      )}
      {active && (
        <ChatDialog open={!!active} onOpenChange={(o) => { if (!o) { setActive(null); loadThreads(); window.dispatchEvent(new Event("mm:unread")); } }}
          jobId={active.job_id} craftsmanUserId={active.craftsman_user_id} title={active.other_name} />
      )}
    </div>
  );
}